var _path, _path2, _path3, _path4;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgChatWithUsList3(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.5 11.25V8.75C2.5 5 5 2.5 8.75 2.5H21.25C25 2.5 27.5 5 27.5 8.75V11.25",
    stroke: "#219EBC",
    strokeWidth: 1.875,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M2.5 18.75V21.25C2.5 25 5 27.5 8.75 27.5H21.25C25 27.5 27.5 25 27.5 21.25V18.75",
    stroke: "#219EBC",
    strokeWidth: 1.875,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M14.9948 14.9993C17.296 14.9993 19.1615 13.1339 19.1615 10.8327C19.1615 8.5315 17.296 6.66602 14.9948 6.66602C12.6936 6.66602 10.8281 8.5315 10.8281 10.8327C10.8281 13.1339 12.6936 14.9993 14.9948 14.9993Z",
    stroke: "#219EBC",
    strokeWidth: 1.875,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M22.1604 23.3333C22.1604 20.1083 18.9521 17.5 15.0021 17.5C11.0521 17.5 7.84375 20.1083 7.84375 23.3333",
    stroke: "#219EBC",
    strokeWidth: 1.875,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChatWithUsList3);
export default __webpack_public_path__ + "static/media/chatWithUsList3.65b2b72d557d203f495c8737fa8a0fac.svg";
export { ForwardRef as ReactComponent };